(function () {

    function getActiveTagFromUrl() {
        const match = window.location.pathname.match(/\/tagged\/([^/]+)/);
        return match ? match[1] : '';
    }

    function initBlogFilter() {
        const container = document.querySelector('.main-blog');
        const tags = document.querySelector('.blog-tags');
        const ajaxWrapper = document.getElementById('BlogAjaxContent');

        if (!container || !tags || !ajaxWrapper) return;

        // Restore active state from URL (THIS FIXES IT)
        const activeTag = getActiveTagFromUrl();

        tags.querySelectorAll('.blog-tag').forEach(b => {
            const isActive = (b.dataset.tag || '') === activeTag;
            b.classList.toggle('active', isActive);
        });

        if (tags.dataset.initialized) return;
        tags.dataset.initialized = 'true';

        tags.addEventListener('click', function (e) {
            if (!(e.target instanceof HTMLElement)) return;

            const btn = e.target.matches('.blog-tag')
                ? e.target
                : e.target.closest('button.blog-tag');

            if (!btn || !tags.contains(btn)) return;

            e.preventDefault();

            const selectedTag = btn.dataset.tag || '';

            tags.querySelectorAll('.blog-tag')
                .forEach(b => b.classList.toggle(
                    'active',
                    (b.dataset.tag || '') === selectedTag
                ));

            let url = container.dataset.blogUrl;
            if (selectedTag) {
                url += `/tagged/${selectedTag}`;
            }
            url += '?view=ajax';

            container.classList.add('is-loading');

            fetch(url)
                .then(r => r.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const newContent = doc.getElementById('BlogAjaxContent');
                    if (!newContent) return;
                    ajaxWrapper.innerHTML = newContent.innerHTML;

                    // Update URL so pagination keeps working
                    history.pushState({}, '', url.replace('?view=ajax', ''));
                })
                .finally(() => {
                    container.classList.remove('is-loading');
                });
        });
    }

    document.addEventListener('DOMContentLoaded', initBlogFilter);
    document.addEventListener('shopify:section:load', initBlogFilter);

})();